/* Accordion for product page */
(function () {
  var accordion = document.getElementById("produkt-accordion");
  if (!accordion) return;

  var items = accordion.querySelectorAll(".pd-accordion-item");

  items.forEach(function (item) {
    if (item.dataset.static === "true") return;

    var header = item.querySelector(".pd-accordion-header");
    var body = item.querySelector(".pd-accordion-body");

    header.addEventListener("click", function () {
      var isOpen = item.classList.contains("is-open");

      if (isOpen) {
        item.classList.remove("is-open");
        body.style.maxHeight = null;
        header.setAttribute("aria-expanded", "false");
      } else {
        item.classList.add("is-open");
        body.style.maxHeight = body.scrollHeight + "px";
        header.setAttribute("aria-expanded", "true");
      }
    });
  });
})();


/* Microsoft Clarity */

    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "wx5xds370r");